let uuid;

function Deferred() {
    return {
        wait: true,
        callbacks: [],
        _exec() {
            let callback;

            while ((callback = this.callbacks.shift())) {
                callback();
            }
        },
        resolve() {
            this.wait = false;
            this._exec();
        },
        always(callback) {
            this.callbacks.push(callback);

            if (!this.wait) {
                this._exec();
            }
        },
    };
}

function ts() {
    return new Date().valueOf();
}

const RADAR = (function () {
    const project = 'cloud';

    const buildCounter = function (mainLabel, mainValue) {
        let time = ts();
        const mainTime = time;
        const data = [];
        const globalPrefix = 'worker';

        return {
            params: {},

            add(label, value) {
                data.push({
                    label,
                    time: ts(),
                    value,
                });

                return this;
            },

            timeEnd(label) {
                data.push({
                    label,
                    time: ts(),
                    value: null,
                });

                return this;
            },

            kaktam(file, message) {
                this.__kaktam = {
                    file,
                    message,
                };

                return this;
            },

            param(name, value) {
                if (name) {
                    this.params[name] = value;
                }
            },

            send(settings) {
                settings = settings || {};

                if (this.alreadySent) {
                    throw new Error(`This counter '${mainLabel}' already sended to server`);
                }

                let ON_PREMISE;
                if (typeof window !== 'undefined') {
                    ON_PREMISE = !/mail\.ru/.test(window.location.hostname);
                } else {
                    ON_PREMISE = !/mail\.ru/.test(self.location.hostname);
                }

                const series = [];
                const params = [];

                for (const set of data) {
                    let value;

                    if (set.value === undefined) {
                        value = set.time - time;
                    } else if (set.value === null) {
                        value = set.time - mainTime;
                    } else {
                        value = set.value;
                    }

                    const label = set.label;
                    series.push(`${label}:${value}`);
                    time = set.time;
                }

                for (const name in this.params) {
                    if (this.params.hasOwnProperty(name)) {
                        params.push(`${name}=${encodeURIComponent(this.params[name])}`);
                    }
                }

                const email = settings.email;
                const pageId = settings.pageId;
                let split = settings.split;
                const prefix = settings.prefix;

                if (split) {
                    if (!Array.isArray(split)) {
                        split = [split];
                    }

                    split = split.join(',');
                }

                let url = `${`//xray.mail.ru/update?uuid=`}${uuid}&p=${project}&t=${globalPrefix}_${mainLabel}${prefix || ''}&v=${
                    mainValue === undefined ? ts() - mainTime : mainValue
                }${series.length ? `&i=${series.join(',')}` : ''}&rnd=${Math.random()}${email ? `&email=${email}` : ''}${
                    split ? `&split=${split}` : ''
                }${pageId ? `&x-page-id=${pageId}` : ''}${params.length ? `&${params.join('&')}` : ''}`;
                if (this.__kaktam) {
                    url += `&rlog=${project}_${this.__kaktam.file}&rlog_message=${encodeURIComponent(this.__kaktam.message)}`;
                    delete this.__kaktam;
                }

                const d = (this.deferred = new Deferred());

                if (ON_PREMISE) {
                    console.log('RADAR:', url);

                    d.resolve();

                    return this;
                }

                fetch(url, { mode: 'no-cors' })
                    .then(function () {
                        d.resolve();
                    })
                    .catch(function () {
                        d.resolve();
                    });

                this.alreadySent = true;

                return this;
            },

            after(callback) {
                if (this.deferred) {
                    this.deferred.always(callback);
                }

                return this;
            },
        };
    };

    const radar = function (label, value, email) {
        return buildCounter(label, value, email).send();
    };

    radar.ts = ts;

    radar.error = function (label) {
        return buildCounter(`error_${label}`).send();
    };

    radar.group = function (label, value) {
        return buildCounter(label, value);
    };

    radar.deferred = function (label, promise) {
        const group = buildCounter(label);

        promise
            .done(function () {
                group.add('success');
            })

            .fail(function () {
                group.add('error');
            })

            .always(function () {
                group.send();
            });

        return promise;
    };

    radar.setup = function (settings) {
        if (!settings) {
            settings = {};
        }

        uuid = settings.uuid;
    };

    return radar;
})();

module.exports = RADAR;
